// project import
import CommonLayout from 'layout/CommonLayout';
import { MfaVerification } from 'pages/auth/mfa-verification';
import GuestGuard from 'utils/route-guard/GuestGuard';

// auth page imports
import AuthCheckMail from 'pages/auth/check-mail';
import AuthCodeVerification from 'pages/auth/code-verification';
import AuthForgotPassword from 'pages/auth/forgot-password';
import AuthLogin from 'pages/auth/login';
import { MfaSetup } from 'pages/auth/mfa-setup';
import AuthSetPassword from 'pages/auth/set-password';

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <GuestGuard>
                    <CommonLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'mfa-setup',
                    element: <MfaSetup />,
                },
                {
                    path: 'mfa-verification',
                    element: <MfaVerification />,
                },
                {
                    path: '/',
                    element: <AuthLogin />,
                },
                {
                    path: '/login/sso/azure',
                    exact: true,
                    element: <AuthLogin />,
                },
                {
                    path: 'login',
                    element: <AuthLogin />,
                },
                {
                    path: 'forgot-password',
                    element: <AuthForgotPassword />,
                },
                {
                    path: 'check-mail',
                    element: <AuthCheckMail />,
                },
                {
                    path: 'set-password',
                    element: <AuthSetPassword />,
                },
                {
                    path: 'code-verification',
                    element: <AuthCodeVerification />,
                },
            ],
        },
    ],
};

export default LoginRoutes;
